var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 15.9997L14 18.6663V13.333L18.6667 15.9997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 16.9425V15.0559C2.66699 11.1959 2.66699 9.2652 3.87366 8.02387C5.08166 6.7812 6.98299 6.72787 10.7843 6.61987C12.5843 6.5692 14.4243 6.5332 16.0003 6.5332C17.575 6.5332 19.415 6.5692 21.2163 6.61987C25.0177 6.72787 26.919 6.7812 28.1257 8.02387C29.3337 9.2652 29.3337 11.1972 29.3337 15.0559V16.9425C29.3337 20.8039 29.3337 22.7332 28.127 23.9759C26.919 25.2172 25.019 25.2719 21.2163 25.3785C19.4163 25.4305 17.5763 25.4665 16.0003 25.4665C14.2613 25.4613 12.5225 25.432 10.7843 25.3785C6.98299 25.2719 5.08166 25.2185 3.87366 23.9759C2.66699 22.7332 2.66699 20.8025 2.66699 16.9439V16.9425Z",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.8ec32a532c2ba5e6e18d16c539dcbb82.svg";
export { ForwardRef as ReactComponent };